import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import pagination from '@/views/mixin/page'
import customContainerHeader from '@/components/custom-container-header';
import { page, rolelist, putObj, Status, Delete, IsExistsName, ResetPassword, ExportListData, VendorImportData, GetImportTplUrlForVendor } from '@/api/sys.user';
import util from '@/libs/util.js';
import { LoadData as _LoadData, LoadUserOrganize } from '@/api/SysOrganize';
import store from '@/store/index';
import changeVendorDialog from './components/changeVendorDialog.vue';
import overDeliveryPartDialog from './components/OverDeliveryPart/dialog.vue';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  name: 'Manager',
  mixins: [ExportListMixin],
  components: {
    customContainerHeader: customContainerHeader,
    changeVendorDialog: changeVendorDialog,
    overDeliveryPartDialog: overDeliveryPartDialog
  },
  data: function data() {
    return {
      mainTable: [],
      loading: false,
      titleText: '',
      drawer: false,
      form: {
        USER_NAME: null,
        VENDOR_NAME: null,
        VENDOR_CODE: null,
        SUB_VENDOR_FLAG: null,
        PARENT_VENDOR_CODE: null,
        PARENT_VENDOR_NAME: null,
        VENDOR_EMAIL: null,
        VENDOR_MANAGER_EMAIL: null,
        VENDOR_BARCODE: null,
        ENABLED: true
      },
      roleList: [],
      // 验证
      rules: {
        USER_NAME: [{
          required: true,
          message: this.$t('Manager.PleaseAccount'),
          trigger: 'blur'
        }],
        NICK_NAME: [{
          required: true,
          message: this.$t('Manager.pleaseUserNic'),
          trigger: 'blur'
        }],
        ROLE_ID: [{
          required: true,
          message: this.$t('Manager.pleaseRoles'),
          trigger: ['blur', 'change']
        }],
        ORGANIZE_ID_STRING: [{
          required: true,
          message: this.$t('Manager._3'),
          trigger: ['blur', 'change']
        }],
        VENDOR_NAME: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'blur'
        }],
        VENDOR_CODE: [{
          required: true,
          message: '请输入供应商代码',
          trigger: 'blur'
        }],
        PARENT_VENDOR_CODE: [{
          required: false,
          message: '请输入供应商代码',
          trigger: 'blur'
        }],
        PARENT_VENDOR_NAME: [{
          required: false,
          message: '请输入供应商名称',
          trigger: 'blur'
        }]
      },
      parentTreeList: [],
      casProps: {
        label: 'ORGANIZE_NAME',
        value: 'ID',
        children: 'children',
        checkStrictly: true,
        multiple: true,
        emitPath: true
      },
      planData: [],
      isFhow: true,
      UploadParamVal: {
        organize_id: util.cookies.get('ORG_ID')
      },
      uploadUrlEx: util.cookies.get('userApi') + 'Manager/VendorImportData',
      isShowChangeVendorDialog: false,
      isSUB_VENDOR_FLAG: false,
      // 是否下游供应商
      overDeliveryPart: {
        visible: true
      },
      selection: [],
      formData: {
        Key: '',
        Page: 1,
        Limit: 15
      }
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.formData.Limit = size;
      this.getLoadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      console.log(page);
      this.formData.Page = page;
      this.getLoadData();
    },
    // 是否下游供应商
    SUB_VENDORChange: function SUB_VENDORChange(val) {
      if (val === true) {
        this.rules.PARENT_VENDOR_CODE[0].required = true;
        this.rules.PARENT_VENDOR_NAME[0].required = true;
      } else if (val === false) {
        this.rules.PARENT_VENDOR_CODE[0].required = false;
        this.rules.PARENT_VENDOR_NAME[0].required = false;
        this.form.PARENT_VENDOR_CODE = null;
        this.form.PARENT_VENDOR_NAME = null;
      }
    },
    // 供应商dialog确定
    cbDialogSubmit: function cbDialogSubmit(selectRecords) {
      console.log(selectRecords);
      this.form.VENDOR_CODE = selectRecords.Code;
      this.form.VENDOR_NAME = selectRecords.Name;
      this.$forceUpdate();
    },
    // 供应商dialog关闭
    closeChangeVendorDialog: function closeChangeVendorDialog() {
      this.isShowChangeVendorDialog = false;
    },
    // 点击选择供应商
    handleShowChangeVender: function handleShowChangeVender() {
      var _this = this;

      this.isShowChangeVendorDialog = true;
      this.$nextTick(function () {
        _this.$refs.changeVendorDialog.GetVendorList();
      });
    },
    changeUSER_NAME: function changeUSER_NAME(e) {// this.$forceUpdate()
    },
    changeROLE_ID: function changeROLE_ID(e) {// this.$forceUpdate()
    },
    changeNICK_NAME: function changeNICK_NAME(e) {// this.$forceUpdate()
    },
    changeMOBILE: function changeMOBILE(e) {// this.$forceUpdate()
    },
    changeWORK_WECHAT_ID: function changeWORK_WECHAT_ID(e) {// this.$forceUpdate()
    },
    changeENABLED: function changeENABLED(e) {// this.$forceUpdate()
    },
    changeREMARK: function changeREMARK(e) {// this.$forceUpdate()
    },
    getIndex: function getIndex() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.getLoadData();

                _this2.getRole();

                _this2.getTreeData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChangeCascader: function handleChangeCascader(e) {
      var _this3 = this;

      this.form.ORGANIZE_ID_STRING = [];

      if (e && e.length) {
        e.map(function (item) {
          if (item && item.length) {
            _this3.form.ORGANIZE_ID_STRING.push(item[item.length - 1]);
          }
        });
      }

      this.form.ORGANIZE_ID_STRING = this.form.ORGANIZE_ID_STRING.join(',');
      this.$forceUpdate();
    },
    getTreeData: function getTreeData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _LoadData({
                  Page: 1,
                  Limit: 100000000
                });

              case 2:
                res = _context2.sent;
                _this4.planData = res.data || [];
                _this4.parentTreeList = res.data ? _this4.getTree(res.data) : [];

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 递归
    getTree: function getTree(data) {
      var _this5 = this;

      var pid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var arr = [];
      data.map(function (item) {
        if (item.PARENT_ORGANIZE_ID === pid) {
          item.level = level;
          item.children = _this5.getTree(data, item.ID, level + 1);
          item.disabled = item.ENABLED === 'N';
          arr.push(item);
        }
      });
      return arr;
    },
    exportData: function exportData() {
      ExportListData({
        TYPE_ID: '2',
        ORGANIZE_ID: util.cookies.get('ORG_ID')
      });
      this.$message.success('已添加到 导出列表 中');
      this.setUnreadExportMessionNum(); // if (res.code === 0) {
      //   window.open(`${process.env.VUE_APP_FILE_PATH}${res.data}`)
      // } else {
      //   this.$message.error(res.message)
      // }
    },
    // 获取用户列表
    getLoadData: function getLoadData() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.loading = true;
                params = {
                  Page: _this6.formData.Page,
                  Limit: _this6.formData.Limit,
                  Key: _this6.formData.Key,
                  LIST_ROUTE: store.getters.routerPath,
                  TYPE_ID: '2',
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context3.next = 4;
                return page(params);

              case 4:
                response = _context3.sent;
                console.log('供应商列表', response);
                _this6.loading = false;
                _this6.mainTable = response.data.Items || [];
                _this6.totalPage = response.data.TotalCount || []; // console.log(this.mainTable, '获取用户')

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleFilter: function handleFilter() {
      this.formData.Page = 1;
      this.getLoadData();
    },
    handleCreate: function handleCreate() {
      // this.form = {}
      this.drawer = true;
      this.titleText = '新增供应商账号';
    },
    handleOpenOverDeliveryPartDialog: function handleOpenOverDeliveryPartDialog() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.$refs.overDeliveryPart.open({
          VENDOR_CODE: _this7.selection[0].VENDOR_CODE,
          ORGANIZE_ID: util.cookies.get('ORG_ID')
        });
      });
    },
    // 获取角色列表
    getRole: function getRole() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return rolelist();

              case 2:
                response = _context4.sent;

                if (response.code === 0) {
                  _this8.roleList = response.data || [];
                } else {
                  _this8.roleList = [];
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    change: function change(_ref) {
      var _this9 = this;

      var $index = _ref.$index,
          row = _ref.row;
      this.$confirm(this.$t('Manager.Modifystatus'), this.$t('Manager.prompt'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Status({
                  Id: row.Id,
                  Status: row.IsENABLED
                });

              case 2:
                res = _context5.sent;

                if (res.code === 0) {
                  _this9.getLoadData();

                  _this9.$message({
                    type: 'success',
                    message: _this9.$t('Manager.Succfied')
                  });
                } else {
                  _this9.getLoadData();
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))).catch(function () {
        _this9.getLoadData();

        _this9.$message({
          type: 'info',
          message: _this9.$t('Manager.edit')
        });
      });
    },
    handleEdit: function handleEdit(_ref3) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var row;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                row = _ref3.row;
                console.log('row', row);

                _this10.$set(_this10.form, 'ID', row.Id);

                _this10.$set(_this10.form, 'ROLE_ID', row.Role_Id);

                _this10.$set(_this10.form, 'USER_NAME', row.User_Name);

                _this10.$set(_this10.form, 'NICK_NAME', row.Nick_Name);

                _this10.$set(_this10.form, 'VENDOR_MOBILE', row.VENDOR_MOBILE || '');

                _this10.$set(_this10.form, 'WORK_WECHAT_ID', row.Work_Wechat_Id || '');

                _this10.$set(_this10.form, 'ENABLED', row.IsENABLED);

                _this10.$set(_this10.form, 'REMARK', row.Remark || '');

                _this10.$set(_this10.form, 'ORGANIZE_IDS', []);

                _this10.$set(_this10.form, 'VENDOR_NAME', row.VENDOR_NAME || '');

                _this10.$set(_this10.form, 'VENDOR_CODE', row.VENDOR_CODE || '');

                _this10.$set(_this10.form, 'VENDOR_EMAIL', row.VENDOR_EMAIL || '');

                _this10.$set(_this10.form, 'VENDOR_MANAGER_EMAIL', row.VENDOR_MANAGER_EMAIL || '');

                _this10.$set(_this10.form, 'VENDOR_BARCODE', row.VENDOR_BARCODE || '');

                _this10.$set(_this10.form, 'ORGANIZE_ID_STRING', []);

                if (row.SUB_VENDOR_FLAG === 'Y') {
                  _this10.isSUB_VENDOR_FLAG = true;

                  _this10.$set(_this10.form, 'PARENT_VENDOR_CODE', row.PARENT_VENDOR_CODE || '');

                  _this10.$set(_this10.form, 'PARENT_VENDOR_NAME', row.PARENT_VENDOR_NAME || '');
                }

                _context6.next = 20;
                return _this10.getPeopleList(row.Id);

              case 20:
                // this.form.ORGANIZE_ID_STRING = this.form.ORGANIZE_IDS.join(',')
                // this.$set(
                //   this.form,
                //   'ORGANIZE_ID_STRING',
                //   this.form.ORGANIZE_IDS.join(',')
                // )
                _this10.drawer = true;
                _this10.titleText = '修改供应商';

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this11 = this;

      this.form.TYPE_ID = '2';
      this.form.ORGANIZE_ID = util.cookies.get('ORG_ID');
      console.log('this.form', this.form);
      this.$refs.xuser.validate( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid, errInfo) {
          var response, result;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!valid) {
                    _context7.next = 19;
                    break;
                  }

                  if (!(_this11.form.VENDOR_NAME === null)) {
                    _context7.next = 4;
                    break;
                  }

                  _this11.$message.warning('请选择绑定的供应商');

                  return _context7.abrupt("return");

                case 4:
                  _this11.isSUB_VENDOR_FLAG === true ? _this11.form.SUB_VENDOR_FLAG = 'Y' : _this11.form.SUB_VENDOR_FLAG = 'N';
                  _context7.next = 7;
                  return IsExistsName(_this11.form);

                case 7:
                  response = _context7.sent;
                  console.log(response);

                  if (!(response.code === 0)) {
                    _context7.next = 17;
                    break;
                  }

                  if (!(response.data === true)) {
                    _context7.next = 13;
                    break;
                  }

                  // this.$message.error(this.$t('Manager.userExcite'))
                  _this11.$message.error('该用户已存在或该供应商已绑其他账号');

                  return _context7.abrupt("return", false);

                case 13:
                  _context7.next = 15;
                  return putObj(_this11.form);

                case 15:
                  result = _context7.sent;

                  if (result.code === 0) {
                    _this11.form = {};
                    _this11.drawer = false;

                    _this11.getLoadData();

                    _this11.$notify({
                      title: _this11.$t('Manager.success'),
                      message: _this11.$t('publics.tips.handleSuccess'),
                      type: 'success',
                      duration: 2000
                    });
                  }

                case 17:
                  _context7.next = 19;
                  break;

                case 19:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    cancel: function cancel() {
      var _this12 = this;

      this.form = {};
      this.form.ENABLED = true;
      this.form.ORGANIZE_ID_STRING = [];
      this.form.ROLE_ID = null;
      setTimeout(function () {
        _this12.$refs.xuser.clearValidate();

        _this12.isSUB_VENDOR_FLAG = false;
        _this12.drawer = false;
      }, 0);
    },
    handleDelete: function handleDelete(_ref5) {
      var _this13 = this;

      var row = _ref5.row;
      this.$confirm(this.$t('Manager.deleteUser'), this.$t('Manager.prompt'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _response;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Delete(row.Id);

              case 2:
                _response = _context8.sent;

                if (_response.code === 0) {
                  _this13.$notify({
                    title: _this13.$t('Manager.success'),
                    message: _this13.$t('Manager.succDeleted'),
                    type: 'success',
                    duration: 2000
                  });

                  _this13.getLoadData();
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      })));
    },
    getPeopleList: function getPeopleList(MANAGER_ID) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return LoadUserOrganize({
                  MANAGER_ID: MANAGER_ID,
                  Page: 1,
                  Limit: 100000
                });

              case 2:
                res = _context9.sent;
                data = res.data || [];
                console.log('组织 res', data); // console.log('this.planData',this.planData);

                _this14.form.ORGANIZE_IDS = [];
                data.map(function (item) {
                  // if (item.STATUS === 'Y') {
                  //   this.form.ORGANIZE_IDS.push(item.ORGANIZE_ID)
                  // }
                  _this14.form.ORGANIZE_IDS.push(item.ORGANIZE_ID);
                });
                _this14.form.ORGANIZE_IDS = _toConsumableArray(new Set(_this14.form.ORGANIZE_IDS));
                _this14.form.ORGANIZE_IDS = _this14.form.ORGANIZE_IDS.map(function (item) {
                  return _this14.reverseGetTree(_this14.planData, item);
                });
                _this14.form.ORGANIZE_ID_STRING = _this14.form.ORGANIZE_IDS.join(',');
                _this14.isFhow = false;
                console.log('this.form.ORGANIZE_ID_STRING', _this14.form.ORGANIZE_ID_STRING);
                console.log('this.form.ORGANIZE_IDS', _this14.form.ORGANIZE_IDS);

                _this14.$nextTick(function () {
                  _this14.isFhow = true;
                });

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 递归
    reverseGetTree: function reverseGetTree(data, id) {
      var _this15 = this;

      var arr = [];
      data.map(function (item) {
        if (item.ID === id) {
          if (item.PARENT_ORGANIZE_ID) {
            arr.push.apply(arr, _toConsumableArray(_this15.reverseGetTree(data, item.PARENT_ORGANIZE_ID)));
          }

          arr.push(item.ID);
        }
      });
      return arr;
    },
    // 重置密码
    resetPwd: function resetPwd() {
      var _this16 = this;

      this.$confirm(this.$t('Manager._5'), this.$t('Manager._6'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return ResetPassword(_this16.form);

              case 2:
                res = _context10.sent;

                if (res.code === 0) {
                  _this16.$notify({
                    title: _this16.$t('Manager.success'),
                    message: _this16.$t('Manager._7'),
                    type: 'success'
                  });
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      })));
    },
    // 上传文件前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      // debugger
      var isExcelFile = file.name.endsWith('.xlsx');
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!isExcelFile) {
        this.$message.error(this.$t('publics.file_ext_err'));
        return false;
      }

      if (!isLt2M) {
        this.$message.error(this.$t('publics.file_szie_err'));
        return false;
      }

      this.NaturaLloading = this.$loading({
        lock: true,
        // 同v-loading的修饰符
        text: this.$t('正在上传中...'),
        // 加载文案
        backgroundColor: 'rgba(55,55,55,0.4)',
        // 背景色
        spinner: 'el-icon-loading' // 加载图标

      });
      return isExcelFile && isLt2M;
    },
    // 上传成功后
    handleAvatarSuccess: function handleAvatarSuccess(response) {
      if (response.ErrorInfo.Status === true) {
        this.$message({
          dangerouslyUseHTMLString: true,
          duration: 0,
          showClose: true,
          message: response.ErrorInfo.Message,
          type: 'error'
        });
      } else {
        this.getIndex();
        this.$message({
          type: 'success',
          message: this.$t('se.picsucc')
        });
      }

      this.NaturaLloading.close();
    },
    handleClose: function handleClose() {
      this.$refs.uploadProcess.clearFiles();
    },
    downExcelTpl: function downExcelTpl() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return GetImportTplUrlForVendor();

              case 2:
                res = _context11.sent;

                if (res.code === 0) {
                  util.open("".concat(_this17.$store.getters.getVUE_APP_FILE_PATH, "/").concat(res.data));
                } else {
                  _this17.$message.error(res.message);
                }

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    selectAllEvent: function selectAllEvent() {
      this.selection = this.$refs.xTable.getCheckboxRecords();
    },
    selectChangeEvent: function selectChangeEvent() {
      this.selection = this.$refs.xTable.getCheckboxRecords();
    }
  },
  created: function created() {
    // console.log(this.$btnList.indexOf('ManagerAdd'));
    this.getIndex();
  } // watch: {
  //   form: {
  //     handler () {
  //       this.$forceUpdate()
  //     },
  //     deep: true
  //   }
  // }

};